(ns dre.components.widget.views.common
  {:authors ["Miroslav Smatana"]}
  (:require
   [dre.components.icon :refer [svg fa-icon]]
   [dre.components.tooltip :refer [tooltip-wrapper]]
   [dre.pages.search.events :as search-events]
   [dre.utils.bem :as bem]
   [dre.coll :refer [provide-vector]]
   [dre.i18n.views :refer [tr]]
   [dre.i18n.events :as-alias i18n]
   [re-frame.core :as rf]))

(defn no-result
  [show?]
  [:div {:class (bem/bm :no-result (if show? :visible :invisible))}
   [:span [tr "No results"]]])

(defn title-with-filter
  [_title _filter-keys]
  (fn [title filter-keys]
    (let [filtered? @(rf/subscribe [::search-events/widget-has-filters? (provide-vector filter-keys)])
          filters (provide-vector filter-keys)]
      [:<>
       [tr title]
       (when filtered?
         [tooltip-wrapper "Clear filter" [:span
                                          {:style {:display :inline-block
                                                   :z-index 1000
                                                   :top 2
                                                   :margin-left "0.25em"}
                                           :on-click #(rf/dispatch [::search-events/clear-widget-filters filters])
                                           :on-touch-end #(rf/dispatch [::search-events/clear-widget-filters filters])}
                                          [:span {:class :title-filter}
                                           [fa-icon :filter]]
                                          [:span {:class :title-filter-dismiss}
                                           [svg :common :dismiss]]]])])))